import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLineChart4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"line-chart-4, statistics, graph"} maskId="square-filled-radius-0-stroke-1-IconLineChart4"><path fillRule="evenodd" clipRule="evenodd" d="M3 4V20H2V4H3ZM9.33203 8V20H8.33203V8H9.33203ZM15.6641 12V20H14.6641V12H15.6641ZM21.9961 16V20H20.9961V16H21.9961Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLineChart4;
